<template>
  <el-dialog
    class="kye-dialog__modal-in-tab kye-query-table-dialog-drag noselect"
    :visible.sync="show"
    v-drag
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="escape"
    :canResize="false"
    :showFullScreenButton="false"
    title="个性设置"
    :width="dialogWidth"
    @open="onOpen"
    @close="onClose">
    <div slot="title">
      <span class="el-dialog__title">个性设置</span>
      <duty-auth
        ref="dutyAuth"
        :option="option"
        style="margin-left: 2px;display: inline-block;">
      </duty-auth>
    </div>
    <div class="main-wrap">
      <div class="main-wrap_left">
        <el-autocomplete
          ref="templateFilter"
          v-model="templateKeyMixins"
          clearable
          placeholder="搜索模板名"
          class="tpl-popper"
          popper-class="kye-popper-auto"
          value-key="templateName"
          :trigger-on-focus="false"
          :fetch-suggestions="filterTemplateMixins"
          @select="selectTemplateMixins">
          <i slot="prefix" class="layout layout-search"></i>
        </el-autocomplete>
        <el-scrollbar>
          <draggable
            ref="draggable"
            tag="ul"
            class="tpl-list"
            v-bind="dragOptionsMixins"
            :list="templateListMixins">
            <li class="tpl"
              v-for="(item, index) in templateListMixins"
              :key="index">
              <div
                :class="`name ${modelMixins.templateIndex === index ? 'is-active' : ''}`"
                :title="item.templateName.length > 13 ? item.templateName : ''"
                @click="loadTemplateMixins(index)">
                {{ item.templateName }}
              </div>
              <div v-show="modelMixins.templateIndex === index">
                <i class="el-icon-edit" @click="updateTemplateMixins(index)"></i>
                <i class="el-icon-delete red" @click="removeTemplateMixins(index)"></i>
              </div>
            </li>
            <!-- <li v-if="templateListMixins.length === 0" class="center undraggable">暂无数据</li> -->
          </draggable>
        </el-scrollbar>
      </div>
      <div class="main-wrap_right">
        <el-tabs v-model="active">
          <el-tab-pane
            v-for="(item,i) in tables"
            :key="i"
            v-if="showTablePane(item)"
            :disabled="tableDisabled(item.url)"
            :label="item.option.label || '字段设置'"
            :name="'tab'+i">
            <el-input
              v-if="!tableDisabled(item.url)"
              :ref="'input' + i"
              style="margin-top:4px;"
              placeholder="输入列名后可定位到指定项"
              @keypress.enter.native="hanldeNextClick(i)"
              @input="val => filterChange(val, i)">
              <el-button slot="append" @click="hanldeNextClick(i)">下一个</el-button>
            </el-input>
            <div class="header-title">
              <el-checkbox
                v-model="checkedMap[i].value"
                :indeterminate="checkedMap[i].indeterminate"
                :disabled="tableDisabled(item.url)"
                @change="e => handleCheckAll(e, item.$columns, i, item)">全选
              </el-checkbox>
              <span>字段名(上下拖动排序)</span>
              <div v-if="!tableDisabled(item.url)" class="header-title_right">
                <span class="header-title_expand" v-if="getControlCollapseCol(item)">收起/展开</span>
                <span class="header-title_fixed" v-if="item.option && !item.option.controlFixedCol">固定列</span>
                <span class="header-title_sort">输入序号移动</span>
              </div>
            </div>
            <ul v-if="tableDisabled(item.url)" class="tabs-content">
              <li
                v-for="col in item.$columns"
                :key="col.key"
                class="item_disabled">
                <el-checkbox disabled>{{col.realLabel || col.label}}</el-checkbox>
              </li>
            </ul>
            <div v-else ref="draggableWrapper" class="tabs-content" style="display:flex;">
              <draggable
                :key="checkedMap[i].dragKey"
                ref="draggable"
                tag="ul"
                style="flex:1;"
                :list="item.$columns"
                v-bind="dragOptions">
                <li
                  v-for="(col, index) in item.$columns"
                  :key="col.key"
                  v-if="!col.undraggable"
                  class="item"
                  :class="{'is-active': checkedMap[i].activeKey === col.key, undraggable: col.disabled}">
                  <i v-show="item.option.draggableChild && col.children && col.children.length > 0"
                    :class="!col.expand ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"
                    style="font-size: 14px;position: absolute; top: 4px; left: 0px;color: #c0c4cc;"
                    @click.stop="clickExpand(col)">
                  </i>
                  <el-checkbox
                    v-model="col.$show"
                    :disabled="col.disabledCheckbox !== undefined ? col.disabledCheckbox : col.disabled"
                    :class="{
                      'is-disabled-checkbox': col.disabledCheckbox
                    }"
                    :indeterminate="item.option.draggableChild && col.indeterminate"
                    @change="handleCheck(item.$columns, i, item, col)">
                    {{getColumnLabel(item.$columns, col)}}
                  </el-checkbox>
                  <draggable
                    v-show="!col.expand"
                    :key="checkedMap[i].dragKey + index"
                    ref="draggable"
                    tag="div"
                    style="flex:1;"
                    :list="col.children"
                    v-bind="dragOptions">
                    <div
                      v-for="col2 in col.children"
                      :key="col2.propertyName"
                      v-if="item.option.draggableChild && !col2.undraggable"
                      :class="{'is-active': checkedMap[i].activeKey === col2.key, undraggable: col2.disabled || col.disabled}"
                      class="item">
                      <el-checkbox
                        v-model="col2.$show"
                        :disabled="col2.disabledCheckbox !== undefined ? col2.disabledCheckbox : (col2.disabled || col.disabled)"
                        :class="{
                          'is-disabled-checkbox': col.disabledCheckbox
                        }"
                        @change="setColType(col, item.$columns, i)">{{col2.label}}
                      </el-checkbox>
                      <el-switch
                        v-if="col2.$showExpand && getControlCollapseCol(item)"
                        :key="'child' + col2.key"
                        v-model="col2.$isExpand"
                        class="drag-dialog-switch__expand"></el-switch>
                    </div>
                  </draggable>
                  <el-switch
                    v-if="col.$showExpand && getControlCollapseCol(item)"
                    v-model="col.$isExpand"
                    class="drag-dialog-switch__expand"></el-switch>
                  <el-checkbox
                    v-if="item.option && !item.option.controlFixedCol"
                    v-model="col.$fixed"
                    :disabled="!!col.disabledFixed"
                    @change="fixedChange(col, item)"
                    class="fixed-box">
                  </el-checkbox>
                  <input
                    type="number"
                    :min="1"
                    :max="item.$columns.length"
                    maxlength="3"
                    class="sort-num"
                    :oninput="`if(+value>${item.$columns.length})value=${item.$columns.length}`"
                    onkeypress="return (/[\d|\-|+|.]/.test(String.fromCharCode(event.keyCode || event.which)))"
                    @blur="e => onNumberBlur(e, i, index, col)" />
                </li>
              </draggable>
            </div>
          </el-tab-pane>
          <el-tab-pane
            v-if="option.searchCode && !option.group"
            :disabled="searchDisabled"
            :label="option.label || '快捷查询设置'"
            name="query">
            <el-input ref="searchInput"
                      style="margin-top:4px;"
                      placeholder="输入快捷查询名称可定位到指定项"
                      @keypress.enter.native="handleNextQuery()"
                      @input="val => queryFilterChange(val)">
              <el-button slot="append" @click="handleNextQuery()">下一个</el-button>
            </el-input>
            <div class="header-title">
              <el-checkbox
                v-model="checkedMap.form.value"
                :indeterminate="checkedMap.form.indeterminate"
                :disabled="searchDisabled"
                @change="e => handleCheckAll(e, formFields.$columns, 'form')">全选
              </el-checkbox>
              <span>字段名(上下拖动排序)</span>
            </div>
            <ul v-if="searchDisabled" class="tabs-content">
              <li
                v-for="col in formFields.$columns"
                :key="col.propertyName"
                class="item_disabled">
                <el-checkbox disabled>{{col.label}}</el-checkbox>
              </li>
            </ul>
            <div v-else class="tabs-content" ref="queryFieldsList">
              <draggable
                tag="ul"
                style="flex:1;"
                :list="formFields.$columns"
                v-bind="dragOptions">
                <li
                  v-for="col in formFields.$columns"
                  :key="col.propertyName"
                  v-if="!col.required && !col.undraggable"
                  class="item"
                  :class="{'is-active': queryActiveKey === col.propertyName}">
                  <el-checkbox
                    v-model="col.$show"
                    @change="handleCheck(formFields.$columns, 'form')">{{col.label}}
                  </el-checkbox>
                </li>
                <template slot="header" v-if="disabledFields.length > 0">
                  <li
                    v-for="col in disabledFields"
                    :key="col.propertyName"
                    class="item item_disabled"
                    :class="{'is-active': queryActiveKey === col.propertyName}">
                    <el-checkbox checked disabled>{{col.label}}</el-checkbox>
                  </li>
                </template>
              </draggable>
            </div>
          </el-tab-pane>
          <el-tab-pane
            v-if="option.searchCode && option.group"
            :disabled="searchDisabled"
            :label="option.label || '快捷查询设置'"
            name="queryGroup">
            <QueryGroupDrag ref="queryGroup" :formFields="formFields"></QueryGroupDrag>
          </el-tab-pane>
          <el-tab-pane
            v-if="generic && !generic.group && (generic.showGenericConfig && generic.searchCode)"
            :disabled="searchDisabled"
            :label="generic.label || '通用查询设置'"
            name="genericSearch">
            <div class="header-title">
              <el-checkbox
                v-model="checkedMap.genericSearch.value"
                :indeterminate="checkedMap.genericSearch.indeterminate"
                :disabled="searchDisabled"
                @change="e => handleCheckAll(e, generic.configColumns, 'genericSearch')">全选
              </el-checkbox>
              <span>字段名(上下拖动排序)</span>
            </div>
            <ul v-if="searchDisabled" class="tabs-content">
              <li
                v-for="col in generic.configColumns"
                :key="col.propertyName"
                class="item_disabled">
                <el-checkbox disabled>{{col.columnDisplayName}}</el-checkbox>
              </li>
            </ul>
            <draggable
              v-else
              class="tabs-content"
              tag="ul"
              :list="generic.configColumns"
              v-bind="dragOptions">
              <li
                v-for="col in generic.configColumns"
                :key="col.propertyName"
                class="item">
                <el-checkbox
                  v-model="col.$show"
                  @change="handleCheck(generic.configColumns, 'genericSearch')">{{col.columnDisplayName}}
                </el-checkbox>
              </li>
            </draggable>
          </el-tab-pane>
          <!-- <el-tab-pane
            v-if="depts && depts.length"
            name="dept"
            label="点部设置">
            <ul class="tabs-content">
              <li
                v-for="col in depts"
                :key="col.key+col.label"
                :class="col === selectedDept ? 'item is-active' : 'item'"
                @click="openDept(col)">
                <span class="theme">{{col.label}}</span>
                <span class="fr">{{deptName(col)}}</span>
              </li>
            </ul>
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </div>
    <div slot="footer" style="display: flex;">
      <kye-button
        type="text"
        style="margin-left:4px;"
        class="layout layout-fenxiang"
        @click="showShareDialog">
        分享
      </kye-button>
      <kye-button
        type="text"
        style="margin-left:4px;"
        class="layout layout-reset"
        @click="onReset">
        重置
      </kye-button>
      <span style="flex:1;"></span>
      <el-button
        type="primary"
        icon="layout layout-pen"
        :disabled="!modelMixins.templateId"
        @click="saveTemplateMixins">保存
      </el-button>
      <el-button
        type="primary"
        icon="layout layout-saveas"
        @click="createTemplateMixins">另存为
      </el-button>
      <el-button
        v-show="active !== 'dept'"
        type="primary"
        hotkey="ctrl+s"
        :disabled="savedDisabled"
        @click="onSave">应用(S)
      </el-button>
      <el-button @click="show = false">取消</el-button>
    </div>
    <el-dialog
      v-if="depts && depts.length"
      class="kye-dialog__modal-in-tab kye-query-table-dialog-dept"
      :visible.sync="showDept"
      v-drag
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="escape"
      title="点部设置"
      width="720px">
      <div style="display:flex;">
        <ul class="tabs-content" style="flex:1;">
          <li
            v-for="col in depts"
            :key="col.key+col.label"
            :class="col === selectedDept ? 'item is-active' : 'item'"
            @click="setDept(col)">
            <span class="theme">{{col.label}}</span>
            <span class="fr">{{deptName(col)}}</span>
          </li>
        </ul>
        <el-form style="width:340px;margin-left:12px;">
          <el-radio-group v-model="deptRadio" @change="handleDeptChange">
            <el-radio :label="0">组织路径</el-radio>
            <el-radio :label="1">部门</el-radio>
            <el-radio :label="2">点部</el-radio>
          </el-radio-group>
          <el-checkbox-group
            v-show="deptRadio === 0"
            v-model="checkedRoutes"
            :min="1"
            @change="handleRoutesChange">
            <el-checkbox v-for="r in routes" :key="r" :label="r">{{r}}</el-checkbox>
          </el-checkbox-group>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" hotkey="ctrl+s" @click="onSaveDepts">保存(S)</el-button>
        <el-button @click="showDept = false">取消</el-button>
      </div>
    </el-dialog>

    <name-dialog
      ref="nameDialog"
      :escape="escape"
      :model="modelMixins"
      @change="saveTemplateMixins" />
    <share-dialog
      ref="shareDialog"
      class="shareDialog"
      :escape="escape"
      :templates="templateList"
      shareRequestUrl="system.defineSearchFieldTemplate.shareTo"
      updateTemplateNameUrl="system.defineSearchFieldTemplate.updateFieldTemplate"
      businessType="1"
      @close="closeShareDialog"
      @updateTemplateName="shareUpdateTemplateName"
    />
  </el-dialog>
</template>

<script>
  import Draggable from 'vuedraggable'
  import DutyAuth from './drag-duty-dialog'
  import NameDialog from './template-name-dialog'
  import shareDialog from './template-share-dialog'
  import columnsTemplateMixins from './module/columns-template.js'
  import QueryGroupDrag from './query-form-group/query-group-drag.js'

  export default {
    components: { Draggable, DutyAuth, NameDialog, shareDialog, QueryGroupDrag },
    props: {
      option: Object,
      formFields: Object,
      tables: Array,
      depts: Array,
      generic: Object
    },
    mixins: [columnsTemplateMixins],
    data () {
      return {
        show: false,
        isSaved: false, // 未保存，但是用户操作过复选框
        isReset: false, // 重置状态
        savedDisabled: true,
        active: this.option.searchCode ? 'query' : 'tab0',
        dragOptions: {
          draggable: '.item',
          handle: '.item',
          animation: 150,
          filter: '.undraggable',
          ghostClass: 'kye-ghost'
        },
        checkedMap: {
          '0': { value: false, indeterminate: false, length: 0, activeKey: '', dragKey: 'dragKey0', activeIndex: -1 },
          '1': { value: false, indeterminate: false, length: 0, activeKey: '', dragKey: 'dragKey1', activeIndex: -1 },
          form: { value: false, indeterminate: false },
          genericSearch: { value: false, indeterminate: false }
        },
        showDept: false,
        selectedDept: {},
        deptRadio: 0,
        routes: [1, 2, 3, 4, 5, 6, 7, 8, 9],
        checkedRoutes: [],
        escape: true,
        queryActiveKey: '' // 快捷查询匹配字段
      }
    },
    created () {
      this.setActive()
    },
    computed: {
      dialogWidth () {
        const hasCollapsedCol = this.tables.some(item => item.option && item.option.controlCollapseCol)
        const extendColLen = this.searchDisabled ? 0 : (hasCollapsedCol ? 1 : 0)
        return `${600 + extendColLen * 40}px`
      },
      disabledFields () {
        return this.formFields.$columns.filter(v => v.required)
      },
      searchDisabled () {
        // const auth = this.tables[0].url.authCode || this.tables[0].url.method
        const hasAuth = this.tables.find(tab => this.permissionMenus.includes(tab.url.authCode || tab.url.method))
        return this.option.auth ? !hasAuth : false
      },
      permissionMenus () {
        return this.$store.getters.permission.menus
      },
      templateList() {
        return this.templateListMixins.map(item => {
          return {
            id: item.fieldTemplates.map(v => v.id).join(','),
            name: item.templateName || '未知名称',
            batchId: item.batchId
          }
        })
      }
    },
    methods: {
      // 快捷查询 字段过滤
      queryFilterChange (val) {
        val = val.trim()
        if (!val) {
          this.queryActiveKey = ''
          return
        }

        const fields = this.formFields.$columns.filter(item => !item.undraggable)

        const lastItem = fields.map(v => ({ ...v })).reverse().find(item => item.label.includes(val))

        // 如果匹配在末位，需重置匹配
        if (lastItem && this.queryActiveKey === lastItem.propertyName) {
          this.queryActiveKey = ''
        }

        const activeIndex = fields.findIndex(item => this.queryActiveKey === item.propertyName)
        const num = fields.findIndex((item, index) => item.label.includes(val) && index > activeIndex)

        if (num > -1) {
          this.queryActiveKey = fields[num].propertyName
          const liDom = this.$refs.queryFieldsList.querySelector('ul li.item') // 容器
          const height = liDom.getBoundingClientRect().height // 获取一项 高度
          this.$refs.queryFieldsList.scrollTo({ top: num * height, behavior: 'smooth' }) // 滚动到对应高度
        } else {
          this.queryActiveKey = ''
        }
      },
      // 下一个
      handleNextQuery () {
        let value = this.$refs.searchInput && this.$refs.searchInput.currentValue
        if (value) {
          this.queryFilterChange(value)
        }
      },
      // disabledColumns (columns, index) {
      //   let arr = columns.filter(v => v.fixed && !v.undraggable)
      //   this.checkedMap[index].length = arr.length
      //   return arr
      // },
      showShareDialog () {
        if (this.$refs.shareDialog) {
          this.$refs.shareDialog.show = true
        }
      },
      closeShareDialog () {
        if (this.$refs.shareDialog) {
          this.$refs.shareDialog.show = false
        }
      },
      shareUpdateTemplateName (tempateInfo) {
        const { batchId, templateName } = tempateInfo
        const _templateInfo = this.templateListMixins.find(item => item.batchId === batchId)
        _templateInfo && (_templateInfo.templateName = templateName)
      },
      setActive () {
        this.tables.forEach((v, i) => {
          this.$set(this.checkedMap, i, {
            value: false,
            indeterminate: false,
            activeKey: '',
            activeIndex: -1,
            dragKey: 'dragKey' + i,
            length: 0
          })
          let auth = !this.option.auth || this.permissionMenus.includes(v.url.authCode || v.url.method)
          if (this.savedDisabled && auth) {
            this.savedDisabled = false
          }
          const showTablePane = this.showTablePane(v)
          if (auth && this.active === 'query' && showTablePane) {
            this.active = `tab${i}`
          }
        })
      },
      // 隐藏列配置
      showTablePane (item) {
        const showColumnsPane = item.option.showColumnsPane
        if (showColumnsPane === false) {
          return false
        }
        return true
      },
      tableDisabled (url) {
        const auth = url.authCode || url.method
        return this.option.auth ? !this.permissionMenus.includes(auth) : false
      },
      // 全选，全不选
      handleCheckAll (val, arr, key, tab) {
        const show = !!val
        let indeterminate = false
        if (key === 'form') {
          arr.forEach(v => {
            if (!v.required && !v.undraggable) {
              v.$show = !!val
            }
          })
        } else if (key === 'genericSearch') {
          arr.forEach(v => {
            v.$show = !!val
          })
        } else {
          arr.forEach(v => {
            // if ((!v.fixed || v.undraggable) && !v.disabled) {
            if (!v.undraggable && !v.disabled) {
              v.$show = v.disabledCheckbox ? true : show
              if (tab && tab.option && tab.option.draggableChild && v.children) {
                const child = v.children.filter(child => !child.undraggable)
                const len = child.length
                child.forEach(child => {
                  if (!child.disabled && !child.disabledCheckbox) child.$show = show
                })
                v.indeterminate = child.filter(v => v.$show === show).length !== len
              }
            }
          })
          const fields = arr.filter(item => !item.undraggable)
          const checkedCount = fields.filter(item => !!item.$show || !!item.indeterminate).length
          indeterminate = checkedCount > 0 && checkedCount < fields.length
        }
        this.checkedMap[key].value = show
        this.checkedMap[key].indeterminate = indeterminate
      },
      handleCheck (arr, key, tab, col) {
        if (!arr || !arr.length) return
        // 判断全选CheckBox的状态，增加排除disabled的情况
        this.setCheckAllType(key, arr)
        if (tab && tab.option && tab.option.draggableChild) {
          if (col && col.children) {
            const children = col.children
            children.forEach(child => {
              if (!child.undraggable && !child.disabled && !child.disabledCheckbox) child.$show = col.$show
            })

            // 有disabled状态，要么是半选，要么全选
            const disabledChild = children.filter(child => child.disabled || child.disabledCheckbox)
            col.indeterminate = !col.$show && !!disabledChild.length
          }
        }
      },
      /**
       * 判断全选CheckBox的状态，增加排除disabled的情况
       */
      setCheckAllType (key, arr) {
        let flag = null
        let indeterminate = false
        let hasNoCheck = false
        arr.forEach(v => {
          // if (!v.disabled && !v.fixed && !v.undraggable) {
          // 自定义查询 required、undraggable
          // 自定义列 disabled、undraggable
          // 通用查询 无限制字段
          if (!v.required && !v.disabled && !v.undraggable && !v.disabledCheckbox) {
            if (!indeterminate) {
              // 如果有其中一个未半选中状态，证明全选按钮也为半选中状态
              if (v.indeterminate) {
                indeterminate = true
              } else {
                // 获取第一个非不可操作的项作为判断依据
                if (flag === null) {
                  flag = v.$show
                } else {
                  // 如果flag有值，并且没有相同值，则与下一个作为判断
                  indeterminate = v.indeterminate || v.$show !== flag
                }
              }
            }
            // 反向赋值，如果有一个为false，则为不是全选中
            if (!hasNoCheck) hasNoCheck = !v.$show
          }
        })
        this.checkedMap[key].value = !hasNoCheck
        // 如果确定全选，则半选中一定为false状态
        this.checkedMap[key].indeterminate = hasNoCheck ? indeterminate : false
        // 该判断合并上面一起，节省一次遍历复杂度
        // this.checkedMap[key].indeterminate = arr.some(v => {
        //   if (v.disabled || v.fixed) return false
        //   return v.$show !== flag
        // })
      },
      /**
       * 设置列状态
       * @param col
       * @param arr
       * @param tableIndex
       */
      setColType (col, arr, tableIndex) {
        if (col.children && col.children.length) {
          const curChild = col.children.filter(child => !child.undraggable)
          // disabled子级，存储用来对比
          let disabledChild = []
          let showChild = curChild.filter(child => {
            if (child.disabled || child.disabledCheckbox) {
              disabledChild.push(child)
              return false
            }
            return child.$show
          })
          // 根据状态设置一级复选框的状态
          col.$show = curChild.length - disabledChild.length === showChild.length
          let colIndetminate = !col.$show && curChild.some(child => child.$show)
          this.$set(col, 'indeterminate', colIndetminate)
          // 重新设置下全选按钮状态
          if (arr) this.setCheckAllType(tableIndex, arr)
        }
      },
      deptName ({ dept }) {
        if (Array.isArray(dept)) {
          return `组织路径 ${JSON.stringify(dept)}`
        } else if (dept === 1) {
          return '部门'
        } else if (dept === 2) {
          return '点部'
        } else {
          return ''
        }
      },
      setDept (col) {
        let dept = this.selectedDept.dept
        if (Array.isArray(dept) && dept.length === 0) {
          this.$message.warning('请至少勾选一个组织路径')
          return
        }
        this.selectedDept = col
        dept = col.dept
        if (Array.isArray(dept)) {
          this.deptRadio = 0
          this.checkedRoutes = col.dept
        } else {
          this.deptRadio = dept || 0
          this.checkedRoutes = []
        }
      },
      handleDeptChange (val) {
        if (val === 0) {
          this.selectedDept.dept = this.checkedRoutes.sort()
        } else {
          this.selectedDept.dept = val
        }
      },
      handleRoutesChange (val) {
        this.selectedDept.dept = val.sort()
      },
      openDept (col) {
        this.showDept = true
        this.setDept(col)
      },
      onOpen () {
        this.tables.forEach((tab, i) => {
          this.handleCheck(tab.$columns, i, tab)
          // 如果有子节点，设置反向
          if (tab.option.draggableChild) {
            tab.$columns.forEach(col => this.setColType(col, tab.$columns, i))
          }
          // 设置当前设置的扩展列配置: 固定列、默认收起展开
          this.setTabExtendProperty(tab)
        })
        if (this.option.group) {
          this.$nextTick(() => {
            this.$refs.queryGroup.init(this.formFields && this.formFields.$columns)
          })
        }
        this.handleCheck(this.formFields && this.formFields.$columns, 'form')
        this.generic.showGenericConfig && this.handleCheck(this.generic && this.generic.configColumns, 'genericSearch')
        this.$refs.dutyAuth.init(this.tables)
        this.resetTemplateMixins()
        this.getTemplateListMixins()
      },
      onClose () {
        if (!this.isSaved) {
          this.tables.forEach(tab => {
            tab.$columns = tab.columns.map(v => {
              // 判断字段是否被折叠
              v.$show = (!v.$disabeldCollapse && v.$collapse) || v.show
              if (tab.option.draggableChild && v.children && v.children.length) {
                v.children.forEach(child => {
                  child.$show = (!child.$disabeldCollapse && child.$collapse) || child.show
                })
              }
              return v
            })
          })
          if (this.option.searchCode) {
            this.formFields.$columns = this.formFields.columns.map(v => {
              v.$show = v.show
              return v
            })
            if (this.option.group) {
              this.$refs.queryGroup.reset()
            }
          }
        }
        this.isSaved = false
        this.$emit('close')
      },
      /**
       * 2021-08-06
       * @param val 搜索字段
       * @param i 当前页签索引
       * @param mode 操作方式
       */
      filterChange (val, i, mode = 'input') {
        val = val.trim()
        if (val) {
          let tab = this.tables[i]
          let isDraggableChild = tab.option && tab.option.draggableChild
          let num = -1

          let flatArr = []
          // 扁平化处理
          tab.$columns.forEach((v, index) => {
            flatArr.push({ ...v })
            // 如果是显示二级的
            if (isDraggableChild && v.children && v.children.length) {
              v.children.forEach(child => {
                flatArr.push({
                  ...child,
                  _parentkey: v.key,
                  _parentIndex: index
                })
              })
            }
          })

          // 过滤不展示字段
          flatArr = flatArr.filter(item => !item.undraggable)

          // 如果匹配在末位，需重置匹配
          // 实时搜索，需重置匹配
          let last = flatArr.map(v => ({ ...v })).reverse().find(v => v.label.includes(val))
          if ((last && last.key === this.checkedMap[i].activeKey) || mode === 'input') {
            this.checkedMap[i].activeIndex = -1
            this.checkedMap[i].activeKey = ''
          }

          // 模糊匹配
          num = flatArr.findIndex((v, index) => v.label.includes(val) && this.checkedMap[i].activeIndex < index)

          if (num > -1) {
            let obj = flatArr[num]
            this.checkedMap[i].activeKey = obj.key
            this.checkedMap[i].activeIndex = num
            // 是否是二级头，二级头折叠情况，需默认展示
            if (obj._parentkey) {
              this.$set(this.tables[i].$columns[obj._parentIndex], 'expand', false)
            }
            let col = this.tables[i].$columns[0]
            col.$show = !col.$show
            col.$show = !col.$show
            // 处理都是二级头情况，默认先取二级头高度
            const liDom = this.$refs.draggableWrapper[i].querySelector('ul li.item .item') || this.$refs.draggableWrapper[i].querySelector('ul li.item')
            const height = liDom.getBoundingClientRect().height
            this.$refs.draggableWrapper[i].scrollTo({ top: num * height, behavior: 'smooth' })
          }
        } else {
          this.checkedMap[i].activeKey = ''
          this.checkedMap[i].activeIndex = -1
          let col = this.tables[i].$columns[0]
          col.$show = !col.$show
          col.$show = !col.$show
        }
      },
      getTasks (saveType = 'task') {
        let tasks = []
        let menuId = this.option.menuId
        // columns
        for (let i = 0; i < this.tables.length; i++) {
          let tab = this.tables[i]
          let code = tab.searchCode
          if (!code) {
            continue
          }
          // let keys = tab.$columns.filter(v => (v.$show || v.indeterminate) && (!v.fixed || v.undraggable)).map(v => {
          let keys = tab.$columns.filter(v => (v.$show || v.indeterminate)).map(v => {
            if (tab.option && !tab.option.draggableChild) {
              return v.key
            } else {
              if (!v.$show && v.indeterminate) v.$show = v.indeterminate
            }
            let child = []
            if (v.children) {
              v.children.forEach(item => {
                if (item.$show) child.push(item.key)
              })
            }
            return { key: v.key, child }
          })
          if (keys.length === 0) {
            this.$message.warning('请至少保留一列')
            return null
          }

          // 快照字段，保留当前所有配置
          let fieldSnapshot = tab.$columns.reduce((prev, cur) => {
            let obj = { show: !!cur.$show }
            if (cur.children && cur.children.length) {
              obj.children = cur.children.reduce((p, c) => {
                const childKey = c.key
                p[childKey] = { show: !!c.$show }
                if (c.$showExpand && this.getControlCollapseCol(tab)) {
                  p[childKey].collapsed = !c.$isExpand
                }
                return p
              }, {})
            }
            // 仅为可编辑收起展开-保存状态
            if (cur.$showExpand && this.getControlCollapseCol(tab)) {
              obj.collapsed = !cur.$isExpand
            }
            prev[cur.key] = obj
            return prev
          }, {})

          tasks.push({ menuId, genericId: this.option[code], fieldContent: JSON.stringify(keys), fieldSnapshot: JSON.stringify(fieldSnapshot) })
        }
        // form
        let code = this.option.searchCode
        if (code) {
          let keys = this.formFields.$columns.filter(v => v.required || v.$show).map(v => v.propertyName)
          if (this.formFields.$columns.length && keys.length === 0) {
            this.$message.warning('请至少保留一个查询条件')
            return null
          }
          // 快照字段，保留当前所有配置 个性设置的显示隐藏用的是$show,所以快照字段也用$show
          let fieldSnapshot = this.formFields.$columns.reduce((prev, cur, index) => {
            prev[cur.propertyName] = { show: cur.$show, index: index }
            return prev
          }, {})

          tasks.push({ menuId, genericId: this.option[code], fieldContent: JSON.stringify(keys), fieldSnapshot: JSON.stringify(fieldSnapshot) })
        }

        // generic
        let genericCode = this.generic.searchCode
        if (genericCode && this.generic.showGenericConfig) {
          let keys = this.generic.configColumns.filter(v => v.$show).map(v => v.propertyName)
          if (this.generic.configColumns.length && keys.length === 0) {
            this.$message.warning('请至少保留一个查询条件')
            return null
          }
          // 快照字段，保留当前所有配置
          let fieldSnapshot = this.generic.configColumns.reduce((prev, cur) => {
            prev[cur.propertyName] = { show: cur.show }
            return prev
          }, {})

          tasks.push({ menuId, genericId: this.option[genericCode], fieldContent: JSON.stringify(keys), fieldSnapshot: JSON.stringify(fieldSnapshot) })
        }

        // 2022-12-01 可根据场景判断是否允许保存
        let fn = this.option.beforeFieldsSubmit
        if (fn && typeof fn === 'function') {
          const findCode = (genericId) => Object.keys(this.option).find(key => this.option[key] === genericId)
          const data = []
          tasks.forEach(item => {
            let userArr = JSON.parse(item.fieldContent)
            if (userArr[0].child) {
              userArr = userArr.reduce((prev, cur) => {
                cur.child.length ? prev.push(...cur.child) : prev.push(cur.key)
                return prev
              }, [])
            }
            data.push({
              searchCode: findCode(item.genericId),
              fields: userArr
            })
          })
          if (fn(data) === true) {
            return null
          }
        }

        return tasks
      },
      onSave () {
        const tasks = this.getTasks()
        if (!tasks) {
          return
        }
        // form
        let code = this.option.searchCode
        let method = 'system.genericSearch.field.saveOrUpdate'
        tasks.forEach(v => this.$http(method, v))
        this.tables.forEach(tab => {
          if (tab.searchCode) {
            tab.columns = tab.$columns.map(v => {
              v.show = v.$show
              // 主动设置为false，使用折叠功能隐藏表格字段
              if (v.hasOwnProperty('$collapse')) {
                // 根据实际配置设置折叠状态
                v.$collapse = v.$isExpand !== undefined ? !v.$isExpand : false
              }
              if (v.hasOwnProperty('collapsed')) {
                v.collapsed = v.$isExpand !== undefined ? !v.$isExpand : v.collapsed
              }
              if (v.children && Array.isArray(v.children)) {
                v.children.forEach(c => {
                  c.show = tab.option.draggableChild ? c.$show : v.$show
                  if (c.hasOwnProperty('$collapse')) {
                    c.$collapse = c.$isExpand !== undefined ? !c.$isExpand : false
                  }
                  if (c.hasOwnProperty('collapsed')) {
                    c.collapsed = c.$isExpand !== undefined ? !c.$isExpand : c.collapsed
                  }
                })
              }
              return v
            })
             tab.option && !tab.option.controlFixedCol && this.saveFixedColumn(tab)
          }
        })
        if (code) {
          this.formFields.$columns.forEach(v => v.show = v.$show)
          this.formFields.columns.length = 0
          this.formFields.columns.push(...this.formFields.$columns)
        }
        this.isSaved = true
        this.$message.success('保存成功')
        this.show = false
        this.$emit('save', 'save')
      },
      async onSaveDepts () {
        let res = this.depts.reduce((s, v) => {
          s[`${v.type || 'list_'}${v.key}`] = v.dept || ''
          return s
        }, {})
        await this.onSubmit(this.option.deptSearchCode, res)
        this.$emit('dept-change', res)
        this.$message.success('点部配置保存成功')
        this.showDept = false
      },
      onSubmit (code, keys) {
        return this.$http('system.genericSearch.field.saveOrUpdate', {
          menuId: this.option.menuId,
          genericId: this.option[code],
          fieldContent: JSON.stringify(keys)
        })
      },
      deleteUserConfig (code) {
        let params = {
          menuId: this.option.menuId,
          genericId: this.option[code]
        }
        if (this.active.includes('tab')) {
          const index = +this.active.replace('tab', '')
          const tab = this.tables[index]
          // 列权限，增加apicode表示
          if (tab.option.authColunms) {
            params.apiCode = tab.url.method
          }
        }
        return this.$http('system.genericSearch.field.reset', params)
      },
      async onReset () {
        this.isReset = false
        if (this.active === 'query' || this.active === 'queryGroup') {
          await this.setFormFields()
        } else if (this.active === 'genericSearch') {
          await this.setGenericSearchFields()
        } else {
          await this.setColumns()
        }
        if (this.isReset) {
          this.isSaved = true
          this.$message.success('重置成功')
          this.show = false
          this.$emit('save', 'reset')
        }
      },
      setGenericSearchFields () {
        const code = this.generic.searchCode
        const columns = this.option['common_' + code] || []
        this.generic.configColumns = columns.map(v => ({ ...v, $show: true }))
        this.deleteUserConfig(code)
        this.isReset = true
      },
      async setFormFields () {
        const code = this.option.searchCode
        const columns = this.option['common_' + code] || '[]'
        let originArr = [] // 原始数据
        try {
          const data = await this.deleteUserConfig(code)
          originArr = JSON.parse(data.genericSearch) || JSON.parse(columns) || [] // 通用查询最新配置

          let arr = this.formFields.$columns
          arr = originArr.map(col => {
            const findField = arr.find(item => col.propertyName === item.propertyName)
            if (findField) {
              findField.show = findField.$show = !!col.show || !!findField.required
              return findField
            }
            return col
          })
          this.formFields.$columns = arr
          this.formFields.columns.length = 0
          this.formFields.columns.push(...arr)
        } catch (e) {
          window._apm && window._apm('captureException', new Error(`【ERP:dragDialog${e}`))
        }
        this.isReset = true
      },
      async setColumns () {
        const index = +this.active.replace('tab', '')
        const tab = this.tables[index]
        const code = tab.searchCode
        const draggableChild = tab.option && tab.option.draggableChild // 是否显示二级头勾选
        const columns = this.option['common_' + code] || '[]' // 刷新页面后最新的配置
        let originArr = [] // 原始数据
        let userKeys = [] // 保存过的一级头
        let userChildKeys = {} // 保存过的二级头
        let flag = false
        try {
          const data = await this.deleteUserConfig(code)
          userKeys = JSON.parse(data.jobTemplate) || []
          originArr = JSON.parse(data.genericSearch) || JSON.parse(columns) || [] // 通用查询最新配置
          originArr = originArr.filter(v => !(v.children && Array.isArray(v.children) && v.children.length === 0)) // 过滤二级头情况，列权限会导致二级头全部被隐藏

          // 用户保存数据处理
          userKeys = userKeys.map(item => {
            if (typeof item === 'string') return item
            if (item.child && item.child.length) userChildKeys[item.key] = item.child
            return item.key || ''
          })
          flag = !!userKeys.length

          let arr = this.tables[index].$columns
          arr = originArr.map(col => {
            const findCol = arr.find(item => col.key === item.key)
            if (findCol) {
              findCol.show = findCol.$show = flag ? userKeys.includes(col.key) : !!col.show
              if (draggableChild && findCol.children && Array.isArray(findCol.children)) {
                // 重置子级节点
                let childMap = {}
                findCol.children.forEach(c => childMap[c.key] = c)
                let children = col.children.map(child => {
                  const childCol = childMap[child.key]
                  if (childCol) {
                    childCol.show = childCol.$show = flag ? (userChildKeys[col.key] && userChildKeys[col.key].includes(child.key)) : !!child.show
                    if (childCol.hasOwnProperty('$collapse')) {
                      childCol.$collapse = childCol.collapse
                      childCol.$disabeldCollapse = false
                    }
                  }
                  return childCol || child
                })
                findCol.children = children
              }
              // 默认折叠标识
              if (findCol.hasOwnProperty('$collapse')) {
                findCol.$collapse = col.collapse
                findCol.$disabeldCollapse = false
              }
              // 重置-当前tab扩展属性
              this.resetTabExtendProperty(tab, findCol, col)
              return findCol
            }

            const show = !!col.show
            col.show = show
            col.$show = show
            if (col.children && Array.isArray(col.children)) {
              col.children.forEach(child => {
                const childShow = draggableChild && show ? !!child.show : show
                child.show = childShow
                child.$show = childShow
              })
            }
            return col
          })

          this.tables[index].$columns = arr
          this.tables[index].columns = arr.slice()
        } catch (e) {
          window._apm && window._apm('captureException', new Error(`【ERP:dragDialog${e}`))
        }
        this.isReset = true
      },
      showReset () {
        if (this.active === 'dept') {
          return false
        }
        if (this.active === 'query') {
          return !!this.option['common_' + this.option.searchCode]
        }
        if (this.active === 'genericSearch') {
          return !!this.option['common_' + this.generic.searchCode]
        }
        let index = +this.active.replace('tab', '')
        let code = this.tables[index].searchCode
        return !!this.option['common_' + code]
      },
      getColumnLabel (columns, col) {
        const label = col.realLabel || col.label
        // let start = index + 1 - this.checkedMap[tableIndex].length
        const findIndex = columns.filter(item => !item.undraggable).findIndex(item => item.key === col.key)
        return `${findIndex + 1}. ${label}`
      },
      onNumberBlur (e, tableIndex, oldIndex, col) {
        let newIndex = +e.target.value
        if (newIndex && newIndex > 0) {
          e.target.value = ''
          let columns = this.tables[tableIndex].$columns
          columns.splice(newIndex - 1, 0, columns.splice(oldIndex, 1)[0])
          this.checkedMap[tableIndex].activeKey = col.key
          // 更改高亮字段后，需重置搜索高亮索引
          this.checkedMap[tableIndex].activeIndex = -1
          // 改变key属性值，强制渲染draggable
          // 否则会触发draggable的onDragUpdate方法，此时this.context未赋值
          this.checkedMap[tableIndex].dragKey = Math.random().toString()
        }
      },
      /**
       * 2021-07-03
       * 展开隐藏
       */
      clickExpand (col) {
        // col.expand = !col.expand
        this.$set(col, 'expand', !col.expand)
      },
      /**
       * 2021-08-08
       * 支持下一个 enter
       */
      hanldeNextClick (index) {
        let currentValue = this.$refs[`input${index}`] && this.$refs[`input${index}`][0].currentValue
        if (currentValue) {
          this.filterChange(this.$refs[`input${index}`][0].currentValue, index, 'nextBtn')
        }
      },
      getControlCollapseCol (tab) {
        const tabOption = tab.option
        return tabOption && tabOption.controlCollapseCol
      },
      // 设置当前设置的扩展列属性: 固定列、默认收起展开
      setTabExtendProperty (tab) {
        const tabOption = tab.option
        const controlFixedCol = tabOption && !tabOption.controlFixedCol
        const controlCollapseCol = this.getControlCollapseCol(tab)
        if (!controlFixedCol && !controlCollapseCol) return
        tab.$columns.forEach(col => {
          // 设置固定列设置属性
          if (controlFixedCol) {
            this.setFixedCol(col)
          }
          // 设置默认收起展开默认值
          if (controlCollapseCol) {
            this.setCollapseCol(col)
          }
        })
      },
      // 重置-当前tab扩展属性
      resetTabExtendProperty (tab, userCol, col) {
        const tabOption = tab.option
        if (!tabOption) return
        // 重置固定列
        !tabOption.controlFixedCol && this.resetFixedColumn(tab, userCol, col)
        // 重置收起展开默认值
        if (this.getControlCollapseCol(tab)) {
          this.resetCollapseCol(tab, userCol, col)
        }
      },
      /**
       * 2021-08-18
       * 设置固定列
       */
      setFixedCol (col) {
        const hasFixed = !!(col.fixed && col.fixed === 'left')
        col.$fixed = hasFixed
      },
      setFixedColumn (tab) {
        tab.$columns.forEach(col => {
          this.setFixedCol(col)
        })
      },
      /**
       * 2021-08-18
       * 重置动态固定列
       */
      resetFixedColumn (tab, userCol, col) {
        this.updateFixedColumn(tab, 'reset')

        userCol.$fixed = !!(col.fixed && col.fixed === 'left') || (col.children && Array.isArray(col.children) && col.children.some(child => child.fixed && child.fixed === 'left'))
        userCol.fixed = userCol.$fixed ? 'left' : ''
      },
      /**
       * 2021-08-18
       * 设置固定列，浏览器缓存
       */
      saveFixedColumn (tab) {
        this.updateFixedColumn(tab)

        // 设置表格列
        tab.columns = tab.$columns.map(v => {
          if (v.$fixed) {
            v.fixed = 'left'
            // 有子集的需把所有子集加上固定列
            // if (v.children && v.children.length) {
            //   v.children.forEach(child => {
            //     child.fixed = 'left'
            //   })
            // }
          } else {
            v.fixed = ''
            // 有子集的需把所有子集加上固定列
            if (v.children && v.children.length) {
              v.children.forEach(child => {
                child.fixed = ''
              })
            }
          }
          return v
        })
      },
      /**
       * 2021-08-18
       * 更新缓存固定列
       */
      updateFixedColumn (tab, type = 'update') {
        let c = this.getFixedColumn()
        let tag = `${this.$route.meta.tag}?${tab.searchCode}`
        // 清空
        if (type === 'reset') {
          delete c[tag]
        } else {
          // 缓存
          let keys = tab.$columns
            .filter(v => v.$fixed)
            .map(v => v.key)
          c = { ...c, [tag]: keys }
        }

        localStorage.setItem('GLOBAL_FIXED_COL', JSON.stringify(c))
      },
      /**
       * 2021-08-18
       * 获取缓存固定列
       */
      getFixedColumn () {
        let column = localStorage.getItem('GLOBAL_FIXED_COL')
        if (column && !/^\{/.test(column)) {
          localStorage.removeItem('GLOBAL_FIXED_COL')
        }
        return JSON.parse(localStorage.getItem('GLOBAL_FIXED_COL') || '{}')
      },
      /**
       * 2021-08-18
       * 实时计算列宽，判断是否超过宽度
       */
      fixedChange (col, tab) {
        // let res = localStorage.getItem('GLOBAL_COL_WIDTH') || '{}'
        // res = JSON.parse(res)
        // let curCol = res[`${this.$route.meta.tag}?${tab.searchCode}`]
        // let fixedWidth = tab.$columns.reduce((pre, cur) => {
        //   let w = 0
        //   if (cur.$fixed) {
        //     if (Array.isArray(cur.children) && cur.children.length > 0) {
        //       w += cur.children.reduce((preChild, curChild) => {
        //         let total = (curCol && curCol[curChild.key]) || parseInt(curChild.width)
        //         return preChild + total
        //       }, 0)
        //     } else {
        //       w = (curCol && curCol[cur.key]) || parseInt(cur.width)
        //     }
        //   }
        //   return pre + w
        // }, 0)
        // let $canvas = this.$parent.$el.querySelector('.box canvas')
        // if ($canvas) {
        //   let maxWidth = parseInt($canvas.style.width)
        //   if (fixedWidth >= maxWidth - 350) {
        //     col.$fixed = !col.$fixed
        //     this.$message.warning('固定列不能超过屏幕显示宽度')
        //   }
        // }
      },
      // 设置列展开-收缩默认值
      setCollapseCol (col) {
        const hasCollapseKeys = col.collapseKeys && col.collapseKeys.length > 0
        col.$showExpand = !!hasCollapseKeys
        col.$isExpand = col.$isExpand !== undefined ? col.$isExpand : !!(!col.collapsed && hasCollapseKeys)
        if (col.children && col.children.length) {
          col.children.forEach(child => {
            this.setCollapseCol(child)
          })
        }
      },
      // 重置列展开-收缩默认值
      resetCollapseCol (tab, userCol, col) {
        // 重置为属性配置值
        userCol.$showExpand = col.collapseKeys && col.collapseKeys.length > 0
        userCol.$isExpand = !col.collapsed
        userCol.collapsed = col.collapsed
        if (col.children && col.children.length) {
          const userChild = userCol.children || []
          col.children.forEach(child => {
            this.resetCollapseCol(tab, userChild, child)
          })
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/scss/variable.scss';
  .kye-query-table-dialog-drag > div > .el-dialog__body {
      padding: 0;
      overflow-y: hidden;
  }
  .kye-query-table-dialog-drag {
    .main-wrap {
      display: flex;
      width: 100%;
      &_left {
        width: 172px;
        border-right: 1px solid #dcdbe2;
        .tpl-popper {
          padding: 6px;
          .el-input__inner {
            padding-left: 24px !important;
            padding-right: 6px !important;
            border-radius: 14px;
            color: #333333;
            border-color: #dbdae6;
            background-color: #ffffff;
          }
          .el-input__prefix {
            top: 5px;
            padding-left: 4px;
            font-size: 14px;
            color: #b3b1b1;
          }
        }
        .tpl-list {
          overflow: auto;
          .tpl {
            height: 24px;
            display: flex;
            align-items: center;
            padding: 0 6px;
            &:hover {
              background-color: #f1f1f5;
            }
            .name {
              flex: 1;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow-x: hidden;
              cursor: pointer;
              font-size: 12px;
              max-width: 160px;
              padding: 4px 0;
            }
            .el-icon-edit {
              color: var(--g-color-primary);
              cursor: pointer;
            }
            .el-icon-delete {
              cursor: pointer;
            }
            .is-active {
              color: #ff9300;
              max-width: 126px;
            }
          }
        }
        .el-scrollbar {
          height: calc(45vh + 50px);
        }
        .el-scrollbar__wrap {
          height: 100%;
          overflow: auto;
        }
        .el-scrollbar__bar.is-horizontal {
          display: none;
        }
      }
      &_right {
        flex: 1;
        padding: 0 16px;
        overflow: hidden;
      }
    }
    .el-tabs__nav-next, .el-tabs__nav-prev {
      line-height: 28px;
    }
    .el-dialog__body {
      padding-top: 4px;
    }
    .el-checkbox {
      width: 76%;
    }
    // 兼容分享弹窗的tree里面的checkbox
    .shareDialog{
      .el-checkbox {
        width: auto;
      }
    }
    .tabs-content {
      height: 45vh;
      overflow-y: auto;
      .el-checkbox__label {
        padding-left: 50px;
      }
      .el-checkbox.is-disabled-checkbox {
        .el-checkbox__label {
          cursor: pointer;
        }
      }
      li {
        /*height: 24px;*/
      }
    }
    .item {
      position: relative;
      margin-right: 54px;
      padding: 1px 16px;
      border-top: 1px solid $--color-24;
      font-size: 12px;
      cursor: pointer;
      .item {
        margin-right: 0;
        .drag-dialog-switch__expand {
          right: 84px;
        }
      }
      // 默认展开-收起
      .drag-dialog-switch__expand {
        position: absolute;
        right: 100px;
        top: 4px;
        width: 28px;
        height: 16px;
        line-height: 16px;
        padding: 0;
        .el-switch__core {
          width: 40px;
          height: 16px;
          &:after {
            width: 12px;
            height: 12px;
          }
        }
        &.is-checked .el-switch__core::after {
          margin-left: -13px;
        }
      }
      .fixed-box {
        position: absolute;
        right: 45px;
        top: 4px;
        width: auto;
      }
      .sort-num {
        position: absolute;
        right: -38px;
        top: 0;
      }
      &:first-child {
        /*border-top: none;*/
        border-top-color: transparent;
      }
      &.is-active {
        background-color: aliceblue;
      }
      &_disabled {
        margin-right: 32px;
        pointer-events: none;
        padding: 1px 16px;
        border-top: 1px solid $--color-24;
        &:first-child {
          border-top: none;
        }
      }
    }
    .header-title {
      margin: 4px 0;
      padding: 4px 16px;
      color: #333;
      font-size: 12px;
      font-weight: 600;
      background-color: $--color-28;
      .el-checkbox {
        width: 62px;
        &__label {
          color: #333;
          font-size: 12px;
          font-weight: 600;
        }
      }
      &_right {
        float: right;
        padding-top: 3px;
      }
      &_expand {
        margin-right: 10px;
      }
      &_fixed {
        margin-right: 10px;
      }
      &_sort {
        // padding-top: 3px;
      }
    }
    .ul_number {
      padding-left: 16px;
      padding-right: 16px;
      li {
        padding-top: 2px;
        padding-bottom: 1px;
      }
    }
  }

  .kye-query-table-dialog-dept {
    .el-checkbox__label {
      padding-left: 4px;
    }
    .tabs-content {
      max-height: 60vh;
      overflow-y: auto;
    }
    .item {
      padding: 6px 12px;
      border-top: 1px solid $--color-24;
      font-size: 12px;
      cursor: pointer;
      &:first-child {
        border-top: none;
      }
      &.is-active {
        background-color: aliceblue;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/query-table/drag-dialog.vue